/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<0b01b489ed1c1a76be31eaf6d02a5664>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type messageRendererHelpseeker$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpseekerMessage">;
  readonly " $fragmentType": "messageRendererHelpseeker";
};
export type messageRendererHelpseeker$key = {
  readonly " $data"?: messageRendererHelpseeker$data;
  readonly " $fragmentSpreads": FragmentRefs<"messageRendererHelpseeker">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "messageRendererHelpseeker",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "helpseekerMessage"
    }
  ],
  "type": "User",
  "abstractKey": "__isUser"
};

(node as any).hash = "8d877f871af32071c37eba719c89ee12";

export default node;
